import { render, staticRenderFns } from "./NavbarSiteSelector.vue?vue&type=template&id=561ae1fe&scoped=true"
import script from "./NavbarSiteSelector.vue?vue&type=script&lang=js"
export * from "./NavbarSiteSelector.vue?vue&type=script&lang=js"
import style0 from "./NavbarSiteSelector.vue?vue&type=style&index=0&id=561ae1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561ae1fe",
  null
  
)

export default component.exports